import React, { useState, useEffect, useRef } from "react";
import { FormControl, Button, Form } from "react-bootstrap";
import { FaSearch, FaTimes } from "react-icons/fa";
import api from "../../api";
import ContainerLoader from "../loader/container-loader";
import { trackEvent } from "../../utils/gaTracking";
import { useSelector } from "react-redux";

const BraingymSearchBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [activeContent, setActiveContent] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isPdfLoading, setIsPdfLoading] = useState(false);
  const searchRef = useRef(null);
  const authState = useSelector((state) => state.authUser);
  const user_id = authState?.profile?.user_id;
  const user_email = authState?.profile?.email;

  const fetchResults = async (searchQuery) => {
    if (!searchQuery || searchQuery.length < 3) {
      setResults([]);
      return;
    }
    try {
      setIsFetching(true);
      const request = { resource: "api/searchbraingym" };
      const response = await api.searchfliphub.addDetails(request, {
        query: searchQuery,
      });
      if (response.status === 200) {
        setResults(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching Town Square search results:", error);
    } finally {
      setIsFetching(false);
    }
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    fetchResults(query);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ✅ highlight matching text with yellow background
  const highlightText = (text, search) => {
    if (!search) return text;
    const regex = new RegExp(`(${search})`, "gi");
    return text.replace(regex, `<mark style="background: yellow">$1</mark>`);
  };

  return (
    <>
      <div className="position-relative pe-3">
        <Button
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(!isOpen);
          }}
          variant="outline-secondary"
          className="navHeader navSearchBar"
        >
          <FaSearch />
        </Button>
      </div>

      {isOpen && (
        <div
          className="position-absolute top-100 start-0 w-100 bg-white shadow p-3 rounded z-3"
          ref={searchRef}
        >
          <Form onSubmit={handleSearchSubmit} className="d-flex">
            <FormControl
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search Brain Gym sessions and videos..."
            />
            {query && (
              <Button
                variant="light"
                className="ms-2"
                onClick={() => setQuery("")}
                disabled={isFetching}
              >
                <FaTimes />
              </Button>
            )}
            <Button
              onClick={handleSearchSubmit}
              variant="primary"
              className="ms-2"
              disabled={isFetching}
            >
              Search
            </Button>
            <Button
              onClick={() => {
                setIsOpen(false);
                setResults([]);
                setQuery("");
              }}
              variant="primary"
              className="ms-2"
              disabled={isFetching}
            >
              Cancel
            </Button>
          </Form>

          <div className="pt-3">
            {isFetching ? (
              <p className="text-muted">Fetching...</p>
            ) : query !== "" && results?.length === 0 ? (
              <p className="text-muted text-center">
                No Results Found! Please refine your query.
              </p>
            ) : null}
          </div>

          <ul
            className="list-group"
            style={{ maxHeight: "300px", overflow: "auto" }}
          >
            {results?.map((episode) => (
              <li
                key={episode.id}
                className="list-group-item list-group-item-action"
              >
                <div className="d-flex align-items-center">
                  <img
                    src={episode.imageurl}
                    alt="preview"
                    className="me-3"
                    style={{ width: "40px", height: "40px" }}
                  />
                  <div>
                    <p
                      className="fw-bold mb-1"
                      dangerouslySetInnerHTML={{
                        __html: highlightText(
                          episode.episode_title || "",
                          query
                        ),
                      }}
                    />
                    <p
                      className="fw-bold mb-1"
                      dangerouslySetInnerHTML={{
                        __html: highlightText(
                          episode.episode_description || "",
                          query
                        ),
                      }}
                    />
                    
                    <div className="d-flex gap-2">
                        {episode.urllink && (
                            <Button
                            size="sm"
                            variant="info"
                            onClick={() => {
                                window.open(episode.urllink, "_blank", "noopener,noreferrer");
                                trackEvent(
                                "braingym_urllink_clicked",
                                "Brain Gym URL Link",
                                episode.episode_title,
                                1,
                                user_id,
                                user_email
                                );
                            }}
                            >
                            Open Link
                            </Button>
                        )}
                        </div>

                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}

    </>
  );
};

export default BraingymSearchBar;
